export enum FeedbackMenuType {
  TAGS,
  TEXT_AREA,
  TEXT_AREA_TAGS
}

export interface FeedbackTag {
  text: string;
  selected: boolean;
}
